export const dictionary = {
  en: {
    app_name: "Mashara Finance",
    login: "Login",
    register: "Register",
    logout: "Logout",
    email: "Email",
    password: "Password",
    name: "Name",
    role: "Role",
    dashboard: "Dashboard",
    companies: "Companies",
    partners: "Partners",
    centers: "Centers",
    projects: "Projects",
    transactions: "Transactions",
    stock: "Stock",
    programs: "Finance (Milestones)",
    batch_management: "Batch Management",
    rate_config: "Rate Configuration",
    reports: "Reports",
    users: "Users",
    investment: "Investment",
    income: "Income",
    expense: "Expense",
    deduction: "Deduction",
    profit: "Profit / Loss",
    total_investment: "Total Investment",
    total_income: "Total Income",
    total_expense: "Total Expense",
    total_deductions: "Total Deductions",
    net_profit: "Net Profit",
    add: "Add",
    edit: "Edit",
    delete: "Delete",
    save: "Save",
    cancel: "Cancel",
    type: "Type",
    amount: "Amount",
    date: "Date",
    description: "Description",
    company: "Company",
    partner: "Partner",
    center: "Center",
    project: "Project",
    work_order: "Work Order",
    by_work_order: "By Work Order",
    actions: "Actions",
    filter: "Filter",
    all: "All",
    monthly_trend: "Monthly Trend",
    breakdown: "Breakdown",
    by_company: "By Company",
    by_partner: "By Partner",
    by_center: "By Center",
    by_project: "By Project",
    no_data: "No data yet",
    export_csv: "Export CSV",
    import_csv: "Import CSV",
    search: "Search",
    welcome: "Welcome back",
    sign_in_to_continue: "Sign in to continue to your dashboard",
    create_account: "Create account",
    new_transaction: "New Transaction",
    new_entry: "New",
    confirm_delete: "Are you sure you want to delete this?",
    distribution: "Distribution",
    language: "Language",
    items: "Items",
    by_item: "By Item",
    quantity: "Quantity",
    attachments: "Attachments",
    settlement: "Partner Settlement",
    net_contribution: "Net Contribution",
    fair_share: "Fair Share",
    adjustment: "Adjustment",
    to_pay: "To Pay",
    to_receive: "To Receive",
    settled: "Settled",
    status: "Status",
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
    approve: "Approve",
    reject: "Reject",
    approval_queue: "Approval Queue",
    user_management: "User Management",
    roles_permissions: "Roles & Permissions",
    approval_log: "Approval Log",
    pending_approvals: "Pending Approvals",
    my_profile: "My Profile",
    advances: "Advances",
    login_history: "Login History",
    assets: "Assets",
    employee_transfers: "Employee Transfers",
    candidates: "Candidate Data",
    bank_guarantees: "Bank Guarantees",
    mis_dashboard: "MIS Dashboard",
    quotations: "Payment Request",
    payment_dashboard: "Payment Dashboard",
    bank_reconciliation: "Bank / Cash Reconciliation",
    vendors: "Vendors",
    approval_workflows: "Approval Workflows",
    partner_associations: "Partner Pairings",
    tds_register: "TDS Register",
    hr_settings: "HR Settings",
    notifications: "SMS & WhatsApp",
    assign_centers: "Assigned Centers",
    assign_partner: "Assigned Partner",
    reject_reason: "Reason (optional)",
    awaiting_approval: "Awaiting admin approval",
    payment_request: "Payment Request",
    partner_ratings: "Partner Ratings",
    partner_settlement: "Partner Settlement",
    invoices: "Invoice & Payment Tracking",
    financial_history: "Employee Payment History",
    subscription: "Subscription & Billing",
    companies_admin: "Companies (Super Admin)",
    center_management: "Center Management",
    entity_mappings: "Entity Mapping",
    course_master: "Course / Job Role Master",
    grp_dashboard: "Dashboard",
    grp_subscription: "Subscription",
    grp_organization: "Organization Management",
    grp_batch: "Batch Management",
    grp_finance: "Finance & Accounting",
    grp_approvals: "Approvals & Workflow",
    grp_candidates: "Candidate / Student Management",
    grp_hr: "Employee / HR Management",
    grp_procurement: "Procurement & Vendors",
    grp_mess: "Mess Management",
    mess_management: "Mess & Inventory",
    grp_partnerships: "Partnerships",
  },
  hi: {
    app_name: "मशारा फाइनेंस",
    login: "लॉगिन",
    register: "रजिस्टर",
    logout: "लॉगआउट",
    email: "ईमेल",
    password: "पासवर्ड",
    name: "नाम",
    role: "भूमिका",
    dashboard: "डैशबोर्ड",
    companies: "कंपनियाँ",
    partners: "पार्टनर्स",
    centers: "केंद्र",
    projects: "प्रोजेक्ट्स",
    transactions: "लेन-देन",
    stock: "स्टॉक",
    programs: "कार्यक्रम",
    batch_management: "बैच प्रबंधन",
    rate_config: "रेट कॉन्फ़िगरेशन",
    reports: "रिपोर्ट",
    users: "उपयोगकर्ता",
    investment: "निवेश",
    income: "आय",
    expense: "खर्च",
    deduction: "कटौती",
    profit: "लाभ / हानि",
    total_investment: "कुल निवेश",
    total_income: "कुल आय",
    total_expense: "कुल खर्च",
    total_deductions: "कुल कटौती",
    net_profit: "शुद्ध लाभ",
    add: "जोड़ें",
    edit: "संपादित",
    delete: "हटाएँ",
    save: "सहेजें",
    cancel: "रद्द",
    type: "प्रकार",
    amount: "राशि",
    date: "तारीख़",
    description: "विवरण",
    company: "कंपनी",
    partner: "पार्टनर",
    center: "केंद्र",
    project: "प्रोजेक्ट",
    work_order: "वर्क ऑर्डर",
    by_work_order: "वर्क ऑर्डर अनुसार",
    actions: "कार्रवाई",
    filter: "फ़िल्टर",
    all: "सभी",
    monthly_trend: "मासिक रुझान",
    breakdown: "विवरण",
    by_company: "कंपनी अनुसार",
    by_partner: "पार्टनर अनुसार",
    by_center: "केंद्र अनुसार",
    by_project: "प्रोजेक्ट अनुसार",
    no_data: "अभी कोई डेटा नहीं",
    export_csv: "CSV एक्सपोर्ट",
    import_csv: "CSV इम्पोर्ट",
    search: "खोज",
    welcome: "वापसी पर स्वागत है",
    sign_in_to_continue: "डैशबोर्ड में जारी रखने के लिए साइन इन करें",
    create_account: "खाता बनाएँ",
    new_transaction: "नया लेन-देन",
    new_entry: "नया",
    confirm_delete: "क्या आप वाक़ई इसे हटाना चाहते हैं?",
    distribution: "वितरण",
    language: "भाषा",
    items: "आइटम",
    by_item: "आइटम अनुसार",
    quantity: "मात्रा",
    attachments: "संलग्नक",
    settlement: "पार्टनर हिसाब-किताब",
    net_contribution: "शुद्ध योगदान",
    fair_share: "उचित हिस्सा",
    adjustment: "समायोजन",
    to_pay: "देना है",
    to_receive: "लेना है",
    settled: "बराबर",
    status: "स्थिति",
    pending: "लंबित",
    approved: "स्वीकृत",
    rejected: "अस्वीकृत",
    approve: "स्वीकार",
    reject: "अस्वीकार",
    approval_queue: "स्वीकृति सूची",
    user_management: "उपयोगकर्ता प्रबंधन",
    roles_permissions: "रोल्स और अनुमतियाँ",
    approval_log: "अनुमोदन लॉग",
    pending_approvals: "लंबित अनुमोदन",
    my_profile: "मेरी प्रोफ़ाइल",
    advances: "अग्रिम राशि",
    login_history: "लॉगिन इतिहास",
    assets: "संपत्ति",
    employee_transfers: "कर्मचारी स्थानांतरण",
    candidates: "कैंडिडेट डेटा",
    bank_guarantees: "बैंक गारंटी",
    mis_dashboard: "MIS डैशबोर्ड",
    quotations: "कोटेशन",
    payment_dashboard: "पेमेंट डैशबोर्ड",
    bank_reconciliation: "बैंक / कैश Reconciliation",
    approval_workflows: "अनुमोदन वर्कफ़्लो",
    partner_associations: "पार्टनर जोड़ी",
    tds_register: "TDS रजिस्टर",
    hr_settings: "HR सेटिंग्स",
    notifications: "SMS और WhatsApp",
    assign_centers: "केंद्र असाइन करें",
    assign_partner: "पार्टनर असाइन करें",
    reject_reason: "कारण (वैकल्पिक)",
    awaiting_approval: "एडमिन स्वीकृति की प्रतीक्षा",
    payment_request: "पेमेंट रिक्वेस्ट",
    partner_ratings: "पार्टनर रेटिंग्स",
    partner_settlement: "पार्टनर सेटलमेंट",
    invoices: "इनवॉइस एवं पेमेंट ट्रैकिंग",
    financial_history: "एम्प्लॉई पेमेंट हिस्ट्री",
    subscription: "सब्सक्रिप्शन एवं बिलिंग",
    companies_admin: "कंपनियां (सुपर एडमिन)",
    center_management: "सेंटर प्रबंधन",
    entity_mappings: "एंटिटी मैपिंग",
    course_master: "कोर्स / जॉब रोल मास्टर",
    grp_dashboard: "डैशबोर्ड",
    grp_subscription: "सब्सक्रिप्शन",
    grp_organization: "संगठन प्रबंधन",
    grp_batch: "बैच प्रबंधन",
    grp_finance: "वित्त एवं लेखा",
    grp_approvals: "अनुमोदन एवं वर्कफ़्लो",
    grp_candidates: "कैंडिडेट / छात्र प्रबंधन",
    grp_hr: "कर्मचारी / HR प्रबंधन",
    grp_procurement: "खरीद एवं वेंडर",
    grp_mess: "मेस प्रबंधन",
    mess_management: "मेस एवं इन्वेंटरी",
    grp_partnerships: "पार्टनरशिप",
  },
};

export function inr(n) {
  const num = Number(n || 0);
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(num);
}
